<template>
  <v-app id="inspire" :dark="darkmode">
    <v-loading ref="loading"></v-loading>
    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"></component>
    </transition>
  </v-app>
</template>


<style>
a:hover{
  text-decoration: none !important;
}
.tile1 {
  margin: 5px;
  border-radius: 4px;
}
.tile > a {
 
  text-decoration: none;
  
}

.tile > .v-list__tile--active {
  
  background: #eee; /* Old browsers */

}

nav1 {
  background: #474747; /* Old browsers */
  background: -moz-linear-gradient(top, #7d7e7d 0%, #0e0e0e 100%); /* FF3.6+ */
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #7d7e7d),
    color-stop(100%, #0e0e0e)
  ); /* Chrome,Safari4+ */
  background: -webkit-linear-gradient(
    top,
    #7d7e7d 0%,
    #0e0e0e 100%
  ); /* Chrome10+,Safari5.1+ */
  background: -o-linear-gradient(
    top,
    #7d7e7d 0%,
    #0e0e0e 100%
  ); /* Opera 11.10+ */
  background: -ms-linear-gradient(top, #7d7e7d 0%, #0e0e0e 100%); /* IE10+ */
  background: linear-gradient(top, #474747 0%, #161616 100%); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7d7e7d', endColorstr='#0e0e0e',GradientType=0 ); /* IE6-9 */
}

@media print {
  @page {
    size: A4;
  }

  /* @page {
    size: A4;
  }
  body * {
    visibility: hidden;
  }

  #printer-content,
  #printer-content * {
    visibility: visible;
  } */

  /* #printer-content {
    position: absolute;
    left: 0;
    top: 0;

  } */
  .noprint {
    display: none;
  }
}
</style>


<script>
import Loading from "./Loading";
import { mapGetters } from "vuex";

// Load layout components dynamically.
const requireContext = require.context("../layouts", false, /.*\.vue$/);

const layouts = requireContext
  .keys()
  .map((file) => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)])
  .reduce((components, [name, component]) => {
    components[name] = component;
    return components;
  }, {});

export default {
  components: {
    "v-loading": Loading,
  },

  metaInfo() {
    const { appName } = window.config;

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`,
    };
  },
  computed: {
    ...mapGetters({
      darkmode: "settings/DARKMODE",
    }),
  },
  data: () => ({
    layout: null,
    defaultLayout: "default",
  }),

  mounted() {
    this.$loading = this.$refs.loading;
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout;
      }

      this.layout = layouts[layout];
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue